import { HoursDisplay } from "../../atoms/HoursDisplay"
import { UtilityNavLink } from "../../atoms/UtilityNavLink"

export interface Props {
  hoursText?: string | null
  navLinks: Array<{ label: string; href: string }>
}

const UtilityBar = ({ hoursText, navLinks }: Props) => {
  return (
    <div className="flex w-full items-center justify-center sm:justify-between bg-[#081C52] py-2 px-4">
      {hoursText ? <HoursDisplay hoursText={hoursText} /> : <span />}
      <nav className="sm:flex items-center gap-4 hidden">
        {navLinks.map(link => (
          <UtilityNavLink key={link.href} label={link.label} href={link.href} />
        ))}
      </nav>
    </div>
  )
}

UtilityBar.displayName = "UtilityBar"

export { UtilityBar }
export default UtilityBar
